import { render, staticRenderFns } from "./Pop2.vue?vue&type=template&id=a23dae98&scoped=true&"
import script from "./Pop2.vue?vue&type=script&lang=js&"
export * from "./Pop2.vue?vue&type=script&lang=js&"
import style0 from "./Pop2.vue?vue&type=style&index=0&id=a23dae98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23dae98",
  null
  
)

export default component.exports